// extracted by extract-css-chunks-webpack-plugin
module.exports = {"itemList":"BillContainer-eca74ff244835f75"};